import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Gitlab = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M20.892 9.889a.664.664 0 00-.025-.087l-2.104-6.479a.84.84 0 00-.8-.57.822.822 0 00-.789.575l-2.006 6.175H8.834L6.826 3.327a.823.823 0 00-.786-.575h-.006a.837.837 0 00-.795.575L3.133 9.815c0 .005-.005.01-.007.016l-1.067 3.281a1.195 1.195 0 00.435 1.34l9.227 6.706c.167.121.393.12.558-.003l9.229-6.703a1.2 1.2 0 00.435-1.34l-1.051-3.223zM17.97 3.936l1.809 5.566H16.16l1.81-5.566zm-11.94 0l1.812 5.566H4.228L6.03 3.936zm-2.982 9.752a.253.253 0 01-.093-.284l.793-2.437 5.817 7.456-6.517-4.735zm1.499-3.239h3.601l2.573 7.916-6.174-7.916zm7.452 8.794l-2.856-8.798h5.718l-1.792 5.515-1.07 3.283zm1.282-.877l2.467-7.588.106-.329h3.604l-5.586 7.156-.591.761zm7.671-4.678l-6.519 4.733.022-.029 5.794-7.425.792 2.436a.25.25 0 01-.089.285z",
    key: "k0"
  }));
});
Gitlab.displayName = 'Gitlab';
export var GitlabDimensions = {
  height: 24,
  width: 24
};